import { defineComponent as _defineComponent } from 'vue'
import { WidgetType } from '@/modules/shared/types';
import { Port } from '@/modules/shared/Port';

import { onMounted, ref } from 'vue';
import PreviewChartMixed from './chart-mixed.svg';
import PreviewChartScatter from './chart-scatter.svg';
import PreviewChartBars from './chart-bars.svg';
import PreviewChartLine from './chart-line.svg';
import PreviewChartDonut from './chart-donut.svg';
import PreviewChartNumber from './chart-number.vue';
import PreviewChartMap from './chart-map.vue';
import PreviewChartHeatmap from './chart-heatmap.svg';
import PreviewChartTable from './chart-table.svg';
import PreviewChartForecast from './chart-forecast.svg';
import PreviewChartWindrose from './chart-windrose.vue';
import PreviewChartNote from './chart-note.svg';
import PreviewChartBarsStacked from './chart-bars-stacked.svg';
import PreviewChartTimeStacked from './chart-time-stacked.svg';

type Props = {
    type: WidgetType;
    metrics: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChartPreview',
  props: {
    type: null,
    metrics: null
  },
  setup(__props: any) {

const props = __props as {
    type: WidgetType;
    metrics: string[];
};


const unit = ref<string>('');

onMounted(async () => {
    const metricKey = props.metrics[0];
    const metric = await Port.metrics.getMetricByKey(metricKey);
    unit.value = metric?.unit || '';
});

return { __sfc: true,props, unit, WidgetType, PreviewChartMixed, PreviewChartScatter, PreviewChartBars, PreviewChartLine, PreviewChartDonut, PreviewChartNumber, PreviewChartMap, PreviewChartHeatmap, PreviewChartTable, PreviewChartForecast, PreviewChartWindrose, PreviewChartNote, PreviewChartBarsStacked, PreviewChartTimeStacked }
}

})